// removed by extract-text-webpack-plugin
module.exports = {"Paginator":"Paginator__Paginator__3rglm","Dots":"Paginator__Dots__32BYG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Table/Paginator/Paginator.css
// module id = 182
// module chunks = 2